import { UIComponent } from "@aptus/frontend-core";
import { Paper } from "@mui/material";

export const PaperComponent: UIComponent = ({ children }) => <Paper style={{ background: "#F3F3F3" }}>{children}</Paper>;
